import { render, staticRenderFns } from "./VEmployerPricing.vue?vue&type=template&id=4405dbe2&scoped=true&lang=pug"
import script from "./VEmployerPricing.vue?vue&type=script&lang=ts"
export * from "./VEmployerPricing.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerPricing.vue?vue&type=style&index=0&id=4405dbe2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405dbe2",
  null
  
)

export default component.exports